export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12014.88b7f208.jpg";